import { Flex } from "../Flex"
import { Loader } from "./Loader"

export type CenteredLoaderProps = {
  height?: string
  top?: string
  bottom?: string
  left?: string
  right?: string
}

export const CenteredLoader = ({ height, top, bottom, right, left }: CenteredLoaderProps) => (
  <Flex
    alignItems="center"
    justifyContent="center"
    width="100%"
    height={height}
    position={top || bottom || left || right ? `relative` : `static`}
    top={top}
    right={right}
    bottom={bottom}
    left={left}
  >
    <Loader />
  </Flex>
)

CenteredLoader.defaultProps = {
  top: undefined,
  bottom: undefined,
  left: undefined,
  right: undefined,
  height: undefined,
}
